<div class="payment-preview-container">
  <!-- In payment status -->

  <div
    class="header"
    *ngIf="reviewMode === 'waiting-payment'"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <div class="title" fxLayout="row" fxLayoutAlign="center center">
      <span class="icon">
        <img src="../../../../../assets/image/bag-shopping.svg" alt=""/>
      </span>
      <div class="title">در انتظار پرداخت</div>
    </div>

    <p style="color: var(--warn)">
      این سفارش بعد از
      <span>{{ deletionTimeEstimate | digitsEnToFa }}</span> دقیقه به صورت
      خودکار حذف خواهد شد
    </p>
  </div>

  <!-- In Progress header -->
  <div
    class="header"
    *ngIf="reviewMode === 'processing'"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <div class="title" fxLayout="row" fxLayoutAlign="center center">
      <span class="icon">
        <img src="../../../../../assets/image/loader-1.svg" alt=""/>
      </span>
      در حال پردازش
    </div>
    <span
      style="color: var(--primary); cursor: pointer"
      [routerLink]="['detailed', payment.factorNumber]"
    >
      جزئیات بیشتر ... <jam-icon name="more"></jam-icon
    ></span>
  </div>

  <!-- Delivered header -->
  <div
    class="header"
    *ngIf="reviewMode === 'delivered'"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
  >
    <span class="icon">
      <img src="../../../../../assets/image/circle-check.svg" alt=""/>
    </span>
    <div class="title">تحویل داده شده</div>
  </div>

  <!-- Canceled header -->
  <div
    class="header"
    *ngIf="reviewMode === 'canceled'"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
  >
    <span class="icon">
      <img src="../../../../../assets/image/circle-x-1.svg" alt=""/>
    </span>
    <div class="title">لغو شده</div>
  </div>
  <div *ngIf="reviewMode === 'processing'" class="process-map"></div>

  <!-- Main information about payment -->
  <div
    class="information"
    fxLayout="row wrap"
    fxLayoutAlign="space-around center"
  >
    <span class="info">
      <span class="title">تاریخ</span>
      <span class="value">{{
          toJalaliDate(payment.createdAt).toString() | digitsEnToFa
        }}</span>
    </span>

    <span class="info">
      <span class="title">شماره سفارش</span>
      <span class="value">{{ payment.factorNumber }}</span>
    </span>

    <span class="info">
      <span class="title">هزینه کل</span>
      <span class="value"
      >{{ payment.amount?.toString() || "0" | irc : "T" | digitsEnToFa }}
      </span>
    </span>

    <span class="info">
      <span class="title">تخفیف</span>
      <span class="value">{{ payment.discountPrice?.toString() || "0" | irc : "T" | digitsEnToFa }}</span>
    </span>

    <span class="info">
      <span class="title">قابل پرداخت</span>
      <span class="value">{{ payment.payablePrice?.toString() || "0" | irc : "T" | digitsEnToFa }}
      </span>
    </span>

  </div>

  <div class="type-icons" fxLayout="row wrap" fxLayoutAlign="start center">
    <div
      class="icon"
      *ngFor="let tag of iconTags"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <div
        *ngIf="tag === 'print'"
        class="print-tag"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/print-icon.svg" alt=""/>
        <span class="title">پرینت</span>
      </div>
      <div
        *ngIf="tag === 'thesis-edit'"
        class="print-tag"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/search.svg" alt=""/>
        <span class="title">ویرایش پایان‌نامه</span>
      </div>
      <div
        *ngIf="tag === 'thesis'"
        class="print-tag"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/study.svg" alt=""/>
        <span class="title"> پایان‌نامه</span>
      </div>
    </div>
  </div>

  <div class="actions" fxLayout="row" fxLayoutAlign="end center">
    <!-- Descriptors -->
    <div
      *ngIf="
        payment?.trackingCode &&
        reviewMode !== 'waiting-payment' &&
        reviewMode !== 'canceled'
      "
      class="tracking-code"
    >
      <span>{{ payment.trackingCode }}</span>
      <button mat-icon-button>
        <jam-icon name="clipboard"></jam-icon>
      </button>
    </div>

    <!-- Buttons -->
    <button
      mat-button
      (click)="cancelPayment()"
      *ngIf="reviewMode === 'waiting-payment'"
      color="warn"
    >
      <jam-icon name="trash"/>
      لغو سفارش
    </button>

    <button
      (click)="complete()"
      *ngIf="reviewMode === 'waiting-payment'"
      mat-raised-button
      color="warn"
    >
      پرداخت
    </button>

    <button
      (click)="trackPayment()"
      *ngIf="
        payment?.trackingCode &&
        reviewMode !== 'waiting-payment' &&
        reviewMode !== 'canceled'
      "
      mat-stroked-button
      color="warn"
      style="border-color: var(--warn)"
    >
      رهگیری سفارش
    </button>
  </div>
</div>
